import { API_URL } from '@/api/url';
import { Http } from '@/lib/http';
import {
  SettlementBillListParams,
  BillDetailParams,
  UpdateDebitNoteParams,
  AdjustBillAmountParams,
  UpdateSupportFileParams,
  AdjustAmountDetailParams,
  SaveExpectedAmountParams,
  SaveTempParams,
  CalculateBillAmountParams
} from '@/types/index.d';

class SettlementBillApi {
  /**
   * 账单结算列表
   * @link mock地址 https://mock.xiaojukeji.com/project/7211/interface/api/857547
   */
  static getSettlementBillList = (params: SettlementBillListParams) => {
    return Http({
      resLatest: API_URL.GetSettlementBillList,
      method: 'GET',
      url: API_URL.GetSettlementBillList,
      params
    });
  };

  /**
   * 账单结算详情
   * @link mock地址 https://mock.xiaojukeji.com/project/7211/interface/api/857549
   */
  static getBillDetail = (params: BillDetailParams) => {
    return Http({
      method: 'GET',
      url: API_URL.GetBillDetail,
      params
    });
  };

  /**
   * 账单凭证列表
   * @link mock地址 https://mock.xiaojukeji.com/project/7211/interface/api/868137
   */
  static getDebitNoteList = (params: BillDetailParams) => {
    return Http({
      method: 'GET',
      url: API_URL.GetDebitNoteList,
      params
    });
  };

  /**
   * 账单审批流&审批记录查询
   * @link mock地址 https://mock.xiaojukeji.com/project/7211/interface/api/858304
   */
  static getApprovalDetail = (params: BillDetailParams) => {
    return Http({
      method: 'GET',
      url: API_URL.GetApprovalDetail,
      params
    });
  };

  /**
   * 上传文件
   * @link mock地址 https://mock.xiaojukeji.com/project/7211/interface/api/857557
   */
  static uploadFile = (params: FormData) => {
    return Http({
      method: 'POST',
      errorToast: false,
      url: API_URL.UploadFile,
      data: params
    });
  };

  /**
   * 更新账单凭证
   * @link mock地址 https://mock.xiaojukeji.com/project/7211/interface/api/868143
   */
  static updateDebitNote = (params: UpdateDebitNoteParams) => {
    return Http({
      method: 'POST',
      errorToast: false,
      url: API_URL.UpdateDebitNote,
      data: params
    });
  };

  /**
   * 上传账单凭证文件流
   * @link mock地址 https://mock.xiaojukeji.com/project/7211/interface/api/882682
   */
  static uploadDebitNote = (params: FormData) => {
    return Http({
      method: 'POST',
      errorToast: false,
      url: API_URL.UploadDebitNote,
      data: params
    });
  };

  /**
   * 上传支持性文件
   * @link mock地址 https://mock.xiaojukeji.com/project/7211/interface/api/869775
   */
  static updateSupportFile = (params: UpdateSupportFileParams) => {
    return Http({
      method: 'POST',
      errorToast: false,
      url: API_URL.UpdateSupportFile,
      data: params
    });
  };

  /**
   * 账单确认
   * @link mock地址 https://mock.xiaojukeji.com/project/7211/interface/api/857566
   */
  static confirmBill = (params: BillDetailParams) => {
    return Http({
      method: 'POST',
      url: API_URL.ConfirmBill,
      data: params
    });
  };

  /**
   * 调整金额
   * @link mock地址 https://mock.xiaojukeji.com/project/7211/interface/api/869119
   */
  static adjustBillAmount = (params: AdjustBillAmountParams) => {
    return Http({
      method: 'POST',
      errorToast: false,
      url: API_URL.AdjustBillAmount,
      data: params
    });
  };

  /**
   * 调整金额撤回
   * @link mock地址 https://mock.xiaojukeji.com/project/7211/interface/api/869124
   */
  static withdrawAdjustBillAmount = (params: BillDetailParams) => {
    return Http({
      method: 'POST',
      errorToast: false,
      url: API_URL.WithdrawAdjustBillAmount,
      data: params
    });
  };

  /**
   * 获取账单调整金额详情
   * @link mock地址 https://mock.xiaojukeji.com/project/7211/interface/api/887702
   */
  static getAdjustAmountDetail = (params: AdjustAmountDetailParams) => {
    return Http({
      resLatest: API_URL.GetAdjustAmountDetail,
      method: 'GET',
      url: API_URL.GetAdjustAmountDetail,
      params
    });
  };

  /**
   * 编辑油站期望金额
   * @link mock地址 https://mock.xiaojukeji.com/project/7211/interface/api/887707
   */
  static saveExpectedAmount = (params: SaveExpectedAmountParams) => {
    return Http({
      method: 'POST',
      errorToast: false,
      url: API_URL.SaveExpectedAmount,
      data: params
    });
  };

  /**
   * 暂存调整金额信息
   * @link mock地址 https://mock.xiaojukeji.com/project/7211/interface/api/887708
   */
  static saveTemp = (params: SaveTempParams) => {
    return Http({
      method: 'POST',
      url: API_URL.SaveTemp,
      data: params
    });
  };

  /**
   * 调整金额页金额计算
   * @link mock地址 https://mock.xiaojukeji.com/project/7211/interface/api/888768
   */
  static calculateBillAmount = (params: CalculateBillAmountParams) => {
    return Http({
      method: 'POST',
      url: API_URL.CalculateBillAmount,
      data: params
    });
  };
}

export default SettlementBillApi;
